module.exports = __webpack_public_path__ + "fonts/NotoSansKR-B.cdc21ec.woff";